export default {
  methods: {
    /**
     * Assert if can use Arta based on restricted categories.
     *
     * Restricted categories:
     * 10191 Cigars
     * 10217 Modern Firearms
     * 10044 Spirits
     * 39 Wine
     * 10016 Automobiles
     *
     * Restricted arta subtypes:
     * firearm_weapon
     *
     * @param {*} invoice
     * @returns bool
     */
    canUseArta (invoice) {
      const restrictedCategories = [10191, 10217, 10044, 39, 10016]
      let canUseArta = this.canUse(invoice, restrictedCategories)
      const restrictedSubtypes = ['firearm_weapon']
      invoice.invoice_items.forEach(value => {
        if (restrictedSubtypes.includes(value.arta_subtype)) {
          canUseArta = false
        }
      })
      // If auction does not allow shipping, don't allow Arta
      if (invoice.auction.allow_shipping === 'n') {
        canUseArta = false
      }
      return canUseArta
    },
    /**
     * Assert if can use Braintree for paymnent based on restricted categories.
     *
     * Restricted categories:
     * 10191 Cigars
     * 10217 Modern Firearms
     * 10016 Automobiles
     *
     * @param {*} invoice
     * @returns bool
     */
    canUseBraintree (invoice) {
      const restrictedCategories = [10191, 10217, 10016]
      return this.canUse(invoice, restrictedCategories)
    },
    /**
     * Assert if can use wire transfer for paymnent based on restricted categories.
     *
     * Restricted categories:
     * No restrictions on wire transfer
     *
     * @param {*} invoice
     * @returns bool
     */
    canUseWireTransfer (invoice) {
      const restrictedCategories = []
      return this.canUse(invoice, restrictedCategories)
    },
    /**
     * Assert if can use check for payment based on restricted categories or customer international status.
     *
     * Restricted categories:
     * 10016 Automobiles
     *
     * @param {*} invoice
     * @returns bool
     */
    canUseCheck (invoice) {
      const isInternational = invoice && invoice.customer_international
      if (isInternational) {
        return false
      }
      const restrictedCategories = [10016]
      return this.canUse(invoice, restrictedCategories)
    },
    /**
     * Assert if can use check for paymnent based on restricted categories.
     *
     * Restricted categories:
     * 10016 Automobiles
     * 10191 Cigars
     *
     * @param {*} invoice
     * @returns bool
     */
    canUseZelle (invoice) {
      const restrictedCategories = [10016, 10191]
      return this.canUse(invoice, restrictedCategories)
    },
    /**
     * Assert <em>something</em> based on categories of invoice items
     *
     * @param {*} invoice
     * @param {*} categories
     * @returns bool
     */
    canUse (invoice, categories) {
      let pass = true
      invoice.invoice_items.forEach(value => {
        if (categories.includes(value.category)) {
          pass = false
        }
      })
      return pass
    },
    /**
     * Assert if invoice has wine or spirits in auction items
     *
     * @param {*} invoice
     */
    containsWineOrSpirits (invoice) {
      const excludesWineOrSpirits = this.canUse(invoice, [10044, 39])
      return excludesWineOrSpirits === false
    },
    /**
     * Validates the state of an invoice
     * @param {*} invoice
     */
    validateInvoice (invoice) {
      if (!invoice) {
        // Invoice not found.
        this.$store.dispatch('setCheckoutInvoiceId', null)
        this.$router.push({ name: 'notFound' })
        return
      }
			let invoiceHasBeenArtaQuoted = false
			let artaQuoteSelected = false
			let invoiceHasBeenCustomQuoted = false
			const itemsInBuilding = []

			// Go through all items on the invoice - see if there is a mixture of restricted and/or non-restricted items
			invoice.invoice_items.forEach(value => {
				// Don't look at shipping charges
				if (value.shipping_charge === 'n') {
					if (value.customer_quoted > 0) {
						invoiceHasBeenArtaQuoted = true
					}

					if (
						value.arta_quote_id !== undefined &&
						value.arta_quote_id !== null
					) {
						artaQuoteSelected = true
					}

					if (
						value.arta_request_id !== null &&
						value.customer_quoted === null &&
						value.arta_quote_id === null
					) {
						invoiceHasBeenCustomQuoted = true
					}

					if (
						value.arta_request_id !== null &&
						value.customer_quoted > 0 &&
						value.arta_quote_id === null
					) {
						this.customQuoteIsQuoted = true
					}
					if (
						value.shipping_charge === 'n' &&
						value.has_left_building !== 'y'
					) {
						itemsInBuilding.push(value)
					}
				}
			})
      if (this.showAlert === false) {
        if (
          Number(invoice.cc_pay_code) === 501 ||
          Number(invoice.cc_pay_code) === 503 ||
          Number(invoice.cc_pay_code) === 504
        ) {
          // 7-14-22 - no longer showing warning messages to customers if they are not allowed to pay with CC, just disable it
          // 6-15-23 - we've been asked to stop show the warning for error code 503 as well, which is when the invoice total is greater than what can be paid with by credit card
          this.creditCardPaymentRestricted = true
        } else if (!this.canUseBraintree(invoice)) {
          this.creditCardPaymentRestricted = true
        } else {
          // No restricted items continue as normal
          this.creditCardPaymentRestricted = false
        }

        // Is invoice allowed to be paid by check
        if (this.canUseCheck(invoice)) {
          this.checkRestricted = false
        } else {
          this.checkRestricted = true
        }

        // Is invoice allowed to be paid by zelle
        if (this.canUseZelle(invoice)) {
          this.zelleRestricted = false
        } else {
          this.zelleRestricted = true
        }

        this.useArta = this.canUseArta(invoice)

        // double check if invoice is paid
        // Only if all items have left the building!
        if (
          invoice.paid_in_full === 'y' &&
          invoice.shipping_order_invoice === true &&
          invoice.selected_payment_type !== '' &&
          invoice.selected_payment_type !== null &&
          invoice.selected_payment_type !== undefined &&
					itemsInBuilding.length === 0
        ) {
          // If invoice is paid and all items have left building, we don't need to be here
          this.alertTitle = 'This invoice has already been paid.'
          this.showAlert = true
          return []
        } else if (
          invoice.paid_in_full === 'n' &&
          (invoice.selected_payment_type === 'check' ||
            invoice.selected_payment_type === 'wire' ||
            invoice.selected_payment_type === 'zelle' ||
            invoice.selected_payment_type === 'ACH')
        ) {
          let typePretty = ''
          if (invoice.selected_payment_type === 'wire') {
            typePretty = 'wire transfer'
            this.alertMessage = `
            <p>
              To complete payment, send the total amount via an electronic
              transfer with the following information.
            </p>
            <div class="wire-transfer-inner">
            <label>Payee:</label>
            <div>Leland Little Auctions</div>

            <label>Bank Information</label>
            <div>Truist Bank</div>

            <label>Account Number</label>
            <div>1340004390562</div>

            <label>ABA Routing Number:</label>
            <div>053101121</div>

            <label>Swift Number:</label>
            <div>BRBTUS33</div>

            <label>Include Text:</label>
            <p>
              ${invoice.customer_display_name} - Invoice #
              ${invoice.invoice_id}
            </p>
            </div>
            If you have any questions, please contact us here: <a href="mailto:info@lelandlittle.com">info@lelandlittle.com</a>`
            this.alertSecondaryAction = {
              label: `Select alternate payment method.`,
              onClick: this.cancelSelectedPaymentMethod
            }
          } else if (invoice.selected_payment_type === 'check') {
            typePretty = 'check'
            this.alertMessage = `<p>
            To complete payment with a Cashier’s Check, Personal Check, or
            Business Check, please make the check out for the full amount
            invoiced and follow the instructions below.
          </p>

          <div class="wire-transfer-inner">
            <label>Make check out to:</label>
            <div>Leland Little Auctions, LTD</div>
            <br />
            <label>Mail to:</label>
            <div>Leland Little Auctions</div>
            <div>620 Cornerstone Court</div>
            <div>Hillsborough, NC 27278</div>
          </div>

          <p class="check-pay-description">
            When paying by Personal or Business Check, we reserve the right
            to hold the item(s) for 7 business days after receiving the
            check, or until the check has cleared, whichever is greater.
          </p>
          If you have any questions, please contact us here: <a href="mailto:info@lelandlittle.com">info@lelandlittle.com</a>`
            this.alertSecondaryAction = {
              label: `Select alternate payment method.`,
              onClick: this.cancelSelectedPaymentMethod
            }
          } else if (invoice.selected_payment_type === 'zelle') {
            typePretty = 'Zelle'
            // Override the message
            this.alertMessage = `<span style="font-weight: 300">Please send funds to <a href="mailto:info@lelandlittle.com">info@lelandlittle.com</a> and reference <span style="white-space: nowrap">invoice # ${invoice.invoice_id}</span> in the memo.</span>
            <br /><br />
            If you have any questions, please contact us here: <a href="mailto:info@lelandlittle.com">info@lelandlittle.com</a>`
            this.alertSecondaryAction = {
              label: `Select alternate payment method.`,
              onClick: this.cancelSelectedPaymentMethod
            }
          } else if(invoice.selected_payment_type === 'ACH') {

            typePretty = 'E-Check'
            this.alertMessage = `<span style="font-weight: 300">We are waiting to receive your funds, please check back later.</span>
            <br /><br />
            If you have any questions, please contact us here: <a href="mailto:info@lelandlittle.com">info@lelandlittle.com</a>`
            this.alertSecondaryAction = null
          }

          this.alertTitle =
            'Thank you for notifying the office of your intended payment by ' +
            typePretty +
            '.'

          this.showAlert = true
          return []
        }

        // check if they already have shipping
        if (invoiceHasBeenArtaQuoted === true && artaQuoteSelected === false) {
          // Pull down shipping options (Don't think should actually be possible, unless they close the browser)
          // So should we just pull down options just as normal?
        }

        // Check if they can use Arta based on the category (safe guard) AND if there is a custom quote
        if (this.canUseArta(invoice) && invoiceHasBeenCustomQuoted) {
          this.customQuoteAlertTitle =
            'Your custom shipping quote is still being prepared, we will email you once it is ready.'
          this.customQuoteAlertMessage = 'If you have any questions, please contact us here: info@lelandlittle.com'
          this.showCustomQuoteAlert = true
          return []
        }

        if (
          (invoiceHasBeenArtaQuoted === true && artaQuoteSelected === true) ||
          (invoice.shipping_order_pick_up === true &&
            this.$router.currentRoute.path.includes('payment') === false) ||
          // If balance is 0 AND nothing to ship, go to summary on payment screen
          (invoice.invoice_balance === 0 && itemsInBuilding.length === 0)
        ) {
          // shipping option has been picked, they need to go straight to payment screen if not already there
          this.skipToPayment = true
        }

        if (invoice.auction.allow_shipping === 'n') {
          this.skipToPayment = true
        }

        return invoice
      }
    },
    /**
     * Allow user to cancel selected pending payment option and return to payment screen
     */
    cancelSelectedPaymentMethod () {
      return this.$store.dispatch('cancelSelectedInvoicePaymentType', {invoice_id: this.invoice.invoice_id}).then(response => {
        // Go to payment screen
        if (this.$router && !this.$router.currentRoute.path.includes('payment')) {
          this.$router.push({ name: 'paymentInfo' })
        }
        this.showAlert = false
      })
    },
    /**
     * Validate inputs for CERTIFIED CARRIER PICKUP
     * @returns bool
     */
    validateThirdPartyPickupDeliveryAddress () {
      let allValid = true

      if (!this.isEmpty(this.pickupPerson)) {
        this.pickupPersonValid = true
      } else {
        allValid = false
        this.pickupPersonValid = false
      }

      if (this.isEmpty(this.rawAddress.street_1)) {
        this.street1Valid = false
        this.street1Error = 'Address is required'
        allValid = false
      } else {
        this.street1Valid = true
      }

      if (!this.isEmpty(this.rawAddress.city)) {
        this.cityValid = true
      } else {
        allValid = false
        this.cityValid = false
      }

      if (!this.isEmpty(this.rawAddress.state)) {
        this.stateValid = true
      } else {
        allValid = false
        this.stateValid = false
      }

      if (!this.isEmpty(this.rawAddress.zip)) {
        this.zipValid = true
      } else {
        allValid = false
        this.zipValid = false
      }

      let countryIsIso = this.sortedCountries.filter(option => {
        return option.iso === this.rawAddress.country
      }).length > 0
      if (this.rawAddress.country !== undefined && this.rawAddress.country !== '' && countryIsIso) {
        this.countryValid = true
      } else {
        this.rawAddress.country = ''
        this.countryValid = false
        allValid = false
      }
      return allValid
    }
  }
}
